<div *ngIf="role && role.id"
      (click)="showList = false; $event.stopPropagation();"
      class="listContainer">
      <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
    <div class="list-title">
        <span class="title">
            {{ 'reg.involved_unit' | translate }}
        </span>
    </div>
    <div class="row p-0 m-0 page-table expanded-list">
        <div class="list-group-collapse duo flex-wrap list-item-container">
            <ng-container *ngFor="let inst of roleInstitutions; let i=index;">
                <ng-container *ngIf="inst.unitId">
                    <div class="duo {{i === 0 ? 'first' : ''}} item list-item">
                        <div class="d-flex justify-content-between col">
                            <div class="w-100 cursor-pointer"
                                (click)="openEdit(getUnitId(inst), inst);$event.stopPropagation();">
                                {{getUnitName(inst)}}
                            </div>
                            <div class="d-flex align-items-center">
                                <confirmation [showTrashIcon]="true"
                                            [question]="'confirm.areyousure'"
                                            [extraClasses]="'d-flex'"
                                            (isConfirmed)="deleteRoleUnit($event, inst)"></confirmation>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!inst.unitId">
                    <div class="list-group-collapse duo flex-wrap list-item-container">
                        <div class="list-item duo item bg-transparent no-shadow {{i === 0 ? 'first' : ''}} ">
                            <drawer-items class="mb-2"
                                [items]="inst.units"
                                [title]="'reg.institution'"
                                (itemSelected)="addRoleUnit(inst, $event)"
                                [openListButtonLabel]="'Select or add unit'"
                                [showAddButton]="true"
                                (askForNew)="openEdit(false, inst, $event)"></drawer-items>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
